<template>
    <div>
        <a-affix :offsetTop="this.$store.getters.shutdownTriggered ? 103 : 50">
            <a-card class="breadcrumb-card" style="z-index: 10">
                <a-row :gutter="[12,12]">
                    <a-col :span="device === 'mobile' ? 24 : 12" style="padding-left: 12px; margin-top: 10px">
                        <breadcrumb :resource="resource">
                            <template #end>
                            </template>
                        </breadcrumb>
                    </a-col>
                    
                    <a-col
                    :span="device === 'mobile' ? 24 : 12"
                    :style="device === 'mobile' ? { float: 'right', 'margin-top': '12px', 'margin-bottom': '-6px', display: 'table' } : { float: 'right', display: 'table', 'margin-top': '6px' }" >
                    
                </a-col>
            </a-row>
        </a-card>
    </a-affix>
    <a-row>
        <a-col :span="24">
            <a-card>
                <a-row :gutter="[12,12]" style="padding-bottom:15px;">
                    <h1 class="onboard-title">{{ $t('label.onboard.first_project') }}</h1>
                </a-row>
                <a-row :gutter="[12,12]">
                    <a-col :span="16" class="block-justify">
                        <p >
                            {{  $t('label.onboard.first_project.intro-00') }}
                        <br />
                        {{  $t('label.onboard.first_project.intro-01') }}
                        <br />&nbsp;<br />
                            <strong>{{ $t('label.onboard.first_project.steps') }}:</strong>
                            <ol>
                                <li>{{ $t('label.onboard.access_section') }} <strong class="text-linube">{{$t('label.projects')}}</strong> {{ $t('label.onboard.in_side_menu')}}</li>
                                <li>{{$t('label.onboard.click_on')}} <strong class="text-linube">{{ $t('label.new.project') }}</strong> y dale un nombre y descripción
                                </li>
                                <li>{{$t('label.onboard.click_on')}} <strong class="text-linube">{{ $t('label.save') }} </strong> para guardarlo</li>
                                <li> {{ $t('label.onboard.clik_tap_icon') }}
                                    <button class="ant-btn ant-btn-dashed ant-btn-circle ant-btn-sm ant-btn-icon-only" type="button">
                                        <span role="img" aria-label="login" class="anticon anticon-login">
                                            <svg focusable="false" class="" data-icon="login" width="1em" height="1em" fill="currentColor" aria-hidden="true" viewBox="64 64 896 896"><defs></defs><path d="M521.7 82c-152.5-.4-286.7 78.5-363.4 197.7-3.4 5.3.4 12.3 6.7 12.3h70.3c4.8 0 9.3-2.1 12.3-5.8 7-8.5 14.5-16.7 22.4-24.5 32.6-32.5 70.5-58.1 112.7-75.9 43.6-18.4 90-27.8 137.9-27.8 47.9 0 94.3 9.3 137.9 27.8 42.2 17.8 80.1 43.4 112.7 75.9 32.6 32.5 58.1 70.4 76 112.5C865.7 417.8 875 464.1 875 512c0 47.9-9.4 94.2-27.8 137.8-17.8 42.1-43.4 80-76 112.5s-70.5 58.1-112.7 75.9A352.8 352.8 0 01520.6 866c-47.9 0-94.3-9.4-137.9-27.8A353.84 353.84 0 01270 762.3c-7.9-7.9-15.3-16.1-22.4-24.5-3-3.7-7.6-5.8-12.3-5.8H165c-6.3 0-10.2 7-6.7 12.3C234.9 863.2 368.5 942 520.6 942c236.2 0 428-190.1 430.4-425.6C953.4 277.1 761.3 82.6 521.7 82zM395.02 624v-76h-314c-4.4 0-8-3.6-8-8v-56c0-4.4 3.6-8 8-8h314v-76c0-6.7 7.8-10.5 13-6.3l141.9 112a8 8 0 010 12.6l-141.9 112c-5.2 4.1-13 .4-13-6.3z"></path></svg>
                                        </span>
                                    </button>
                                     {{$t('label.onboard.first_project_to_access')}}
                                     <img style="max-width:300px;" src="/assets/onboarding/1-project-select.png" /></li>
                                </ol>
                            </p>
                        </a-col>
                        <a-col :span="8" class="block-center">
                            <img class="block-center-img" src="/assets/onboarding/0-project-new.png" />
                        </a-col>
                    </a-row>
                    <a-row>
                        <a-col :span="24" class="block-justify">
                            <h3>{{$t('label.onboard.first_project.access')}}</h3>
                        </a-col>
                        <a-col :span="16" class="block-center">
                            <img class="block-center-img" src="/assets/onboarding/2-project-view.png" />
                            
                        </a-col>
                        <a-col :span="8" class="block-justify">
                            <p >
                                {{  $t('label.onboard.first_project_general_view') }}
                                <br/>
                                {{ $t('label.onboard.first_project.exit') }}
                                <br/>
                            </p>
                        </a-col>
                    </a-row>
                </a-card>
            </a-col>
        </a-row>
    </div>
</template>

<script>
import { mixinDevice } from '@/utils/mixin.js'
import Breadcrumb from '@/components/widgets/Breadcrumb'
export default {
    name: 'DeployNetworkAndInstance',
    components: {
        Breadcrumb,
        
    },
    mixins: [mixinDevice],
    data () {
        return {
            resource: {},
        }
    },
}
</script>

<style scoped>
.breadcrumb-card {
    margin-left: -24px;
    margin-right: -24px;
    margin-top: -16px;
    margin-bottom: 12px;
}

.row-element {
    margin-bottom: 10px;
}

.ant-breadcrumb {
    vertical-align: text-bottom;
}

:deep(.ant-switch-inner) {
    display: block;
    font-size: 14px;
    margin: 0px 14px 0px 28px;
}

:deep(.ant-alert-message) {
    display: flex;
    align-items: center;
}

.hide {
    display: none !important;
}
</style>
